import { lazy } from 'react'

import { RolePermissionGuard } from '@components/RolePermissionGuard'

import type { Route } from '@assets/types/globals'

//statuses routes
const Moderating = lazy(() => import('@pages/Statuses/Moderating').then((module) => ({ default: module.Moderating })))
const Success = lazy(() => import('@pages/Statuses/Success').then((module) => ({ default: module.Success })))

//auth routes
const SignIn = lazy(() => import('@pages/Auth/SignIn').then((module) => ({ default: module.SignIn })))
const ParentsRegistration = lazy(() => import('@pages/Auth/SignUp').then((module) => ({ default: module.ParentsRegistration })))
const ChildrenRegistration = lazy(() => import('@pages/Auth/SignUp').then((module) => ({ default: module.ChildrenRegistration })))
const AdultStudentRegistration = lazy(() => import('@pages/Auth/SignUp').then((module) => ({ default: module.AdultStudentRegistration })))
const StaffRegistration = lazy(() => import('@pages/Auth/SignUp').then((module) => ({ default: module.StaffRegistration })))
const TeacherRegistration = lazy(() => import('@pages/Auth/SignUp').then((module) => ({ default: module.TeacherRegistration })))
const ForgotPassword = lazy(() => import('@pages/Auth/ForgotPassword').then((module) => ({ default: module.ForgotPassword })))
const NewPassword = lazy(() => import('@pages/Auth/NewPassword').then((module) => ({ default: module.NewPassword })))

//common routes
const Home = lazy(() => import('@pages/Home').then((module) => ({ default: module.Home })))
const Chat = lazy(() => import('@pages/Chat').then((module) => ({ default: module.Chat })))
const Profile = lazy(() => import('@pages/Profile').then((module) => ({ default: module.Profile })))
const Children = lazy(() => import('@pages/Profile/Children').then((module) => ({ default: module.Children })))
const StudentProfile = lazy(() => import('@pages/Profile/StudentProfile').then((module) => ({ default: module.StudentProfile })))
const ParentProfile = lazy(() => import('@pages/Profile/ParentProfile').then((module) => ({ default: module.ParentProfile })))
const Schedule = lazy(() => import('@pages/Schedule').then((module) => ({ default: module.Schedule })))
const EditSubject = lazy(() => import('@pages/EditSubject').then((module) => ({ default: module.EditSubject })))
const EditTest = lazy(() => import('@pages/EditTest').then((module) => ({ default: module.EditTest })))
const ExternatSubjects = lazy(() => import('@pages/ExternatSubjects').then((module) => ({ default: module.ExternatSubjects })))
const ExternatSubjectDetails = lazy(() => import('@pages/ExternatSubjectDetails').then((module) => ({ default: module.ExternatSubjectDetails })))

// students routes
const StudentSubjects = lazy(() => import('@pages/Student/StudentSubjects').then((module) => ({ default: module.StudentSubjects })))
const StudentSubjectDetails = lazy(() => import('@pages/Student/StudentSubjectDetails').then((module) => ({ default: module.StudentSubjectDetails })))
const StudentLesson = lazy(() => import('@pages/Student/StudentLesson').then((module) => ({ default: module.StudentLesson })))
const StudentIndividual = lazy(() => import('@pages/Student/StudentIndividual').then((module) => ({ default: module.StudentIndividual })))
const QuarterTest = lazy(() => import('@pages/Student/QuarterTest').then((module) => ({ default: module.QuarterTest })))
const TopicTest = lazy(() => import('@pages/Student/TopicTest').then((module) => ({ default: module.TopicTest })))
const StudentStatistic = lazy(() => import('@pages/Student/StudentStatistic').then((module) => ({ default: module.StudentStatistic })))

// extern routes
const ExternIndividualPlan = lazy(() => import('@pages/Extern/ExternIndividualPlan').then((module) => ({ default: module.ExternIndividualPlan })))
const ExternTest = lazy(() => import('@pages/Extern/ExternTest').then((module) => ({ default: module.ExternTest })))
const ExternSubjectDetails = lazy(() => import('@pages/Extern/ExternSubjectDetails').then((module) => ({ default: module.ExternSubjectDetails })))
const ExternInterview = lazy(() => import('@pages/Extern/ExternInterview').then((module) => ({ default: module.ExternInterview })))

// teacher routes
const TestKnowledge = lazy(() => import('@pages/Teacher/TestKnowledge').then((module) => ({ default: module.TestKnowledge })))
// const TeacherSubjects = lazy(() => import('@pages/Teacher/TeacherSubjects').then((module) => ({ default: module.TeacherSubjects })))
// const TeacherSubjectDetails = lazy(() => import('@pages/Teacher/TeacherSubjectDetails').then((module) => ({ default: module.TeacherSubjectDetails })))
const TeacherMarks = lazy(() => import('@pages/Teacher/TeacherMarks').then((module) => ({ default: module.TeacherMarks })))
const TeacherLesson = lazy(() => import('@pages/Teacher/TeacherLesson').then((module) => ({ default: module.TeacherLesson })))
const TeacherIndividual = lazy(() => import('@pages/Teacher/TeacherIndividual').then((module) => ({ default: module.TeacherIndividual })))
const TeacherHomeWork = lazy(() => import('@pages/Teacher/TeacherHomeWork').then((module) => ({ default: module.TeacherHomeWork })))
const TeacherTestWork = lazy(() => import('@pages/Teacher/TeacherTestWork').then((module) => ({ default: module.TeacherTestWork })))
const TeacherQuarterTest = lazy(() => import('@pages/Teacher/TeacherQuarterTest').then((module) => ({ default: module.TeacherQuarterTest })))
const TeacherQuarterTestProgress = lazy(() => import('@pages/Teacher/TeacherQuarterTestProgress').then((module) => ({ default: module.TeacherQuarterTestProgress })))
const TeacherTopicTest = lazy(() => import('@pages/Teacher/TeacherTopicTest').then((module) => ({ default: module.TeacherTopicTest })))
const TeacherTopicTestProgress = lazy(() => import('@pages/Teacher/TeacherTopicTestProgress').then((module) => ({ default: module.TeacherTopicTestProgress })))
const TeacherMyClass = lazy(() => import('@pages/Teacher/TeacherMyClass').then((module) => ({ default: module.TeacherMyClass })))
const TeacherWorkload = lazy(() => import('@pages/Teacher/TeacherWorkload').then((module) => ({ default: module.TeacherWorkload })))
const TeacherIndividualPlan = lazy(() => import('@pages/Teacher/TeacherIndividualPlan').then((module) => ({ default: module.TeacherIndividualPlan })))
const TeacherIndividualPlanDetail = lazy(() => import('@pages/Teacher/TeacherIndividualPlanDetail').then((module) => ({ default: module.TeacherIndividualPlanDetail })))
const TeacherInterview = lazy(() => import('@pages/Teacher/TeacherInterview').then((module) => ({ default: module.TeacherInterview })))

// admin routes
const IndividualPlanTemplates = lazy(() => import('@pages/Admin/IndividualPlanTemplates').then((module) => ({ default: module.IndividualPlanTemplates })))
const EditIndividualPlanTemplate = lazy(() => import('@pages/Admin/EditIndividualPlanTemplate').then((module) => ({ default: module.EditIndividualPlanTemplate })))
const AdminIndividualPlan = lazy(() => import('@pages/Admin/AdminIndividualPlan').then((module) => ({ default: module.AdminIndividualPlan })))
const AdminIndividualPlanDetail = lazy(() => import('@pages/Admin/AdminIndividualPlanDetail').then((module) => ({ default: module.AdminIndividualPlanDetail })))
const AdminInvitesNewUsers = lazy(() => import('@pages/Admin/AdminInviteNewUsers').then((module) => ({ default: module.AdminInviteNewUsers })))
const AdminStudents = lazy(() => import('@pages/Admin/AdminStudents').then((module) => ({ default: module.AdminStudents })))
const AdminUpdateStudent = lazy(() => import('@pages/Admin/AdminUpdateStudent').then((module) => ({ default: module.AdminUpdateStudent })))
const AdminStaff = lazy(() => import('@pages/Admin/AdminStaff').then((module) => ({ default: module.AdminStaff })))

const routes: Route[] = [
  {
    title: 'Головна',
    rootPath: '/',
    list: [
      {
        title: '',
        path: '',
        element: <Home />,
      },
      {
        title: '',
        path: 'chats',
        element: <Chat />,
      },
      {
        title: 'Розклад',
        path: 'schedule',
        element: <Schedule />,
      },
      {
        title: '',
        path: 'statistics',
        element: <StudentStatistic />,
      },
      {
        title: '',
        path: 'student-card/:student_id',
        element: <StudentProfile />,
      },
      {
        title: '',
        path: 'parent-card/:parent_id',
        element: <ParentProfile />,
      },
      {
        title: 'Навантаження',
        path: 'workload',
        element: <TeacherWorkload />,
      },
      {
        title: '',
        path: 'individual-plan-templates',
        element: (
          <RolePermissionGuard
            permission={9}
            withRedirect
          >
            <IndividualPlanTemplates />
          </RolePermissionGuard>
        ),
      },
      {
        title: '',
        path: 'individual-plan-templates/:id',
        element: (
          <RolePermissionGuard
            permission={9}
            withRedirect
          >
            <EditIndividualPlanTemplate />
          </RolePermissionGuard>
        ),
      },
      {
        title: '',
        path: 'subjects/:id/edit',
        element: (
          <RolePermissionGuard
            permission={14}
            withRedirect
          >
            <EditSubject />
          </RolePermissionGuard>
        ),
      },
      {
        title: '',
        path: '/test/:id/edit',
        element: (
          <RolePermissionGuard
            permission={14}
            withRedirect
          >
            <EditTest />
          </RolePermissionGuard>
        ),
      },
    ],
  },
  {
    title: 'Student',
    rootPath: 'student',
    list: [
      {
        title: '',
        path: 'subjects',
        element: <StudentSubjects />,
      },
      {
        title: '',
        path: 'subject/:id',
        element: <StudentSubjectDetails />,
      },
    ],
  },
  {
    title: 'Extern',
    rootPath: 'extern',
    list: [
      {
        title: '',
        path: 'subjects',
        element: (
          <RolePermissionGuard
            role={4}
            withRedirect
          >
            <ExternatSubjects />
          </RolePermissionGuard>
        ),
      },
      {
        title: '',
        path: 'subject/:subject_id',
        element: (
          <RolePermissionGuard
            role={4}
            withRedirect
          >
            <ExternSubjectDetails />
          </RolePermissionGuard>
        ),
      },
      {
        title: '',
        path: 'individual-plan',
        element: (
          <RolePermissionGuard
            role={4}
            withRedirect
          >
            <ExternIndividualPlan />
          </RolePermissionGuard>
        ),
      },
      {
        title: '',
        path: 'test/:test_id',
        element: (
          <RolePermissionGuard
            role={[4, 20]}
            withRedirect
          >
            <ExternTest />
          </RolePermissionGuard>
        ),
      },
      {
        title: '',
        path: 'interview/:id',
        element: (
          <RolePermissionGuard
            role={4}
            withRedirect
          >
            <ExternInterview />
          </RolePermissionGuard>
        ),
      },
    ],
  },
  {
    title: 'Teacher',
    rootPath: 'teacher',
    list: [
      {
        title: '',
        path: 'test-knowledge',
        element: <TestKnowledge />,
      },
      {
        title: '',
        path: 'subjects',
        // element: <TeacherSubjects />,
        element: (
          <RolePermissionGuard
            role={[100, 20]}
            withRedirect
          >
            <ExternatSubjects />
          </RolePermissionGuard>
        ),
      },
      {
        title: '',
        path: 'subject/:id',
        // element: <TeacherSubjectDetails />,
        element: (
          <RolePermissionGuard
            role={[100, 20]}
            withRedirect
          >
            <ExternatSubjectDetails />
          </RolePermissionGuard>
        ),
      },
      {
        title: '',
        path: 'subject/:id/marks',
        element: <TeacherMarks />,
      },
      {
        title: '',
        path: 'my-class',
        element: <TeacherMyClass />,
      },
      {
        title: '',
        path: 'quarter-test/:test_id',
        element: <TeacherQuarterTest />,
      },
      {
        title: '',
        path: 'quarter-test/progress/:progress_id',
        element: <TeacherQuarterTestProgress />,
      },
      {
        title: '',
        path: 'topic-test/:test_id',
        element: <TeacherTopicTest />,
      },
      {
        title: '',
        path: 'topic-test/progress/:progress_id',
        element: <TeacherTopicTestProgress />,
      },
      {
        title: '',
        path: 'individual-plan',
        element: (
          <RolePermissionGuard
            permission={10}
            withRedirect
          >
            <TeacherIndividualPlan />
          </RolePermissionGuard>
        ),
      },
      {
        title: '',
        path: 'individual-plan/:id',
        element: (
          <RolePermissionGuard
            permission={10}
            withRedirect
          >
            <TeacherIndividualPlanDetail />
          </RolePermissionGuard>
        ),
      },
      {
        title: '',
        path: 'interview/:id',
        element: (
          <RolePermissionGuard
            permission={10}
            withRedirect
          >
            <TeacherInterview />
          </RolePermissionGuard>
        ),
      },
    ],
  },
  {
    title: 'Admin',
    rootPath: '',
    list: [
      {
        title: 'Створити індивідуальний план',
        path: 'create-individual-plan',
        element: (
          <RolePermissionGuard
            permission={9}
            withRedirect
          >
            <AdminIndividualPlan />
          </RolePermissionGuard>
        ),
      },
      {
        title: 'Створити індивідуальний план',
        path: 'create-individual-plan/:id',
        element: (
          <RolePermissionGuard
            permission={9}
            withRedirect
          >
            <AdminIndividualPlanDetail />
          </RolePermissionGuard>
        ),
      },
      {
        title: 'Запрошення',
        path: '/admin/invitations',
        element: (
          <RolePermissionGuard
            role={[100, 20]}
            withRedirect
          >
            <AdminInvitesNewUsers />
          </RolePermissionGuard>
        ),
      },
      {
        title: 'Список учнів',
        path: '/admin/students',
        element: (
          <RolePermissionGuard
            role={[100, 20]}
            withRedirect
          >
            <AdminStudents />
          </RolePermissionGuard>
        ),
      },
      {
        title: 'Редагувати учня',
        path: '/admin/students/:id',
        element: (
          <RolePermissionGuard
            role={[100, 20]}
            withRedirect
          >
            <AdminUpdateStudent />
          </RolePermissionGuard>
        ),
      },
      {
        title: 'Список співробітників',
        path: '/admin/staff/list',
        element: (
          <RolePermissionGuard
            role={[100, 20]}
            withRedirect
          >
            <AdminStaff />
          </RolePermissionGuard>
        ),
      },
      {
        title: 'Новий співробітник',
        path: '/admin/staff/new',
        element: (
          <RolePermissionGuard
            role={[100, 20]}
            withRedirect
          >
            <StaffRegistration />
          </RolePermissionGuard>
        ),
      },
      {
        title: 'Співробітник',
        path: '/admin/staff/:id',
        element: (
          <RolePermissionGuard
            role={[100, 20]}
            withRedirect
          >
            <StaffRegistration />
          </RolePermissionGuard>
        ),
      },
    ],
  },
]
export default routes

export const lessonLayoutRoutes: Route[] = [
  {
    title: '',
    rootPath: '/',
    list: [
      {
        title: 'Профіль',
        path: 'profile',
        element: <Profile />,
      },
      {
        title: 'Діти',
        path: 'children',
        element: <Children />,
      },
    ],
  },
  {
    title: 'Teacher',
    rootPath: 'teacher',
    list: [
      {
        title: '',
        path: 'lesson',
        element: <TeacherLesson />,
      },
      {
        title: '',
        path: 'individual/:id',
        element: <TeacherIndividual />,
      },
      {
        title: '',
        path: 'home-work',
        element: <TeacherHomeWork />,
      },
      {
        title: '',
        path: 'test-work',
        element: <TeacherTestWork />,
      },
    ],
  },
  {
    title: 'Student',
    rootPath: 'student',
    list: [
      {
        title: '',
        path: 'lesson',
        element: <StudentLesson />,
      },
      {
        title: '',
        path: 'individual/:id',
        element: <StudentIndividual />,
      },
      {
        title: '',
        path: 'quarter-test/:test_id',
        element: <QuarterTest />,
      },
      {
        title: '',
        path: 'topic-test/:test_id',
        element: <TopicTest />,
      },
    ],
  },
]

export const signInRoute: Route[] = [
  {
    title: '',
    rootPath: 'auth',
    list: [
      {
        title: '',
        path: 'sign-in',
        element: <SignIn />,
      },
      {
        title: '',
        path: 'forgot-password',
        element: <ForgotPassword />,
      },
      {
        title: '',
        path: 'new-password',
        element: <NewPassword />,
      },
    ],
  },
]

export const registerRoutes: Route[] = [
  {
    title: 'Реєстрація',
    rootPath: 'sign-up',
    list: [
      {
        title: 'Реєстрація батьків',
        path: 'parents',
        element: <ParentsRegistration />,
      },
      {
        title: 'Реєстрація дітей',
        path: 'children',
        element: <ChildrenRegistration />,
      },
      {
        title: 'Реєстрація повнолітнього учня',
        path: 'student',
        element: <AdultStudentRegistration />,
      },
      {
        title: 'Реєстрація вчителя',
        path: 'teacher',
        element: <TeacherRegistration />,
      },
    ],
  },
]

export const finishStaffRegisterRoutes: Route[] = [
  {
    title: 'Реєстрація',
    rootPath: 'sign-up',
    list: [
      {
        title: 'Встановлення паролю вчителем',
        path: 'staff',
        element: <NewPassword />,
      },
    ],
  },
]

export const statusesRoutes: Route[] = [
  {
    title: '',
    rootPath: '/',
    list: [
      {
        title: 'На модерації',
        path: 'moderating',
        element: <Moderating />,
      },
      {
        title: 'Модерація успішна',
        path: 'success',
        element: <Success />,
      },
    ],
  },
]
